// =========================
// Config de lugares (ejemplo)
// Reemplaza/añade los que necesites. Puedes usar:
// - placeId (tomará foto y coordenadas desde Google)
// - o coords + iconUrl propio
// =========================
let PLACES = [];
let HORARIOS = [];
let jsonTransporte = {}
let jsonReservas = {}

/*
** ENDPOINTS
*/
const UBICACION_ENDPOINT = "https://grupopanaca.com.do/transporteapi/api/transportepanaca/ubicaciones";
const HORARIO_ENDPOINT = "https://grupopanaca.com.do/transporteapi/api/transportepanaca/horarios";

// Tuning
const SHOW_APPROX_ADDRESS = false;
const NEARBY_COUNT = 3; // top N cercanos
const NEARBY_RADIUS_METERS = 2000; // o dentro de este radio
// Caché en memoria para no pedir el mismo placeId varias veces
const PLACE_CACHE = new Map();


// =========================
// Variables compartidas
// =========================
let _map,
  _marker,
  _originSelection,
  _originAutocomplete,
  _geocoder,
  _placesService,
  _lastOrigin,
  _directionsService,
  _directionsRenderer,
  _autocomplete,
  _watchId = null,
  _lastUpdateTs = 0,
  _lastUpdatePos = null,
  _routePolyline = null,
  _routeVertices = null,
  _placeMarkers = [],       // {id, marker, data:{...}, baseIcon, highlightIcon, lastDistance}
  _placesById = {},         // { id: { id, title, position: LatLng, imageUrl, placeId?, coords? } }
  _currentPlace = null;     // { id, title, position:{lat,lng} }
  let horarioId = 0;
  let ubicacionId = 0;
  let quantity = 0;
  let quantityAdults = 0;
  let quantityChilds = 0;

const orgn_input = document.getElementById('orgn-input');
const ride_details = document.getElementById('ride-details');
const ride_distance_value = document.getElementById('ride-distance-value');
const ride_time_value = document.getElementById('ride-time-value');
const ride_cost_value = document.getElementById('ride-cost-value');
const calendar = document.getElementById('myModal');
const $section = document.getElementById('map-container');
const VIAJE_UNIT_PRICE_CENTS = Number($section?.dataset.priceCents || 0);
const STORE_CURRENCY = $section?.dataset.currency || 'USD';
let VIAJE_VARIANT_ID;

function formatMoney(cents) {
  // Si el tema expone Shopify.formatMoney, se usa con el formato de la tienda
  if (typeof shopify !== 'undefined' && shopify.formatMoney && MONEY_FORMAT) {
    return shopify.formatMoney(cents, MONEY_FORMAT);
  }

  // Fallback con Intl
  try {
    return new Intl.NumberFormat(
      STORE_CURRENCY === 'USD' ? 'en-US' : 'es-CO',
      { style: 'currency', currency: 'USD' }
    ).format(cents / 100);
  } catch {
    return (cents / 100).toFixed(2);
  }
}

async function loadData() {
  const [ptsTxt, hrsTxt] = await Promise.all([
    fetch(UBICACION_ENDPOINT).then(r => r.text()),
    fetch(HORARIO_ENDPOINT).then(r => r.text())
  ]);

  const pts = JSON.parse(ptsTxt);
  const hrs = JSON.parse(hrsTxt);

  PLACES = pts
    .filter(p => p.activo)                             // <- camelCase
    .map(p => ({
        id: String(p.transporteUbicacionID),                  // <- camelCase
        title: p.nombre,                           // <- camelCase
        placeId: p.placeID || null,
        precioLocal: p.precioLocal,
        precio: p.precio
    })).sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));

  HORARIOS = hrs.map(h => ({
    id: String(h.transporteHorarioID),
    placesId: String(h.transporteUbicacionID),        // <- clave para el filtro en el card
    horario: h.horario                           // ej. "17:10:00"
  }));

  console.log("UBICACIONES: ", PLACES);
  console.log("HORARIOS: ", HORARIOS);
}

// Persistencia
const LS_KEYS = {
  ORIGIN: 'como_llegar.origin', // {lat,lng,ts}
  DEST: 'como_llegar.dest', // {placeId} | {location:{lat,lng}, title?}
  ROUTE: 'como_llegar.route_state',
};

async function initMap() {
  const el = document.getElementById('map');
  const fallback = { lat: 18.571336158028792, lng: -68.48474174245544 }; //4.60784500778004, -75.81931400635503 -> COORDENADAS DE PANACA COLOMBIA

  _map = new google.maps.Map(el, { mapId: 'DEMO_MAP_ID', zoom: 14, center: fallback });
  _marker = new google.maps.Marker({ position: fallback, map: _map, title: 'Tu ubicación' });
  _geocoder = new google.maps.Geocoder();
  _placesService = new google.maps.places.PlacesService(_map);
  _directionsService = new google.maps.DirectionsService();
  _directionsRenderer = new google.maps.DirectionsRenderer({ map: _map, suppressMarkers: false });

  // UI: FAB + pane
  const panel = document.getElementById('route-panel');
  const form = panel;
  const input = document.getElementById('dest-input');
  const customDestList = document.getElementById('custom-dest-list');
  let _selectedDest = null; // { placeId?, coords?, title , .... }

  // Asegurar que el panel esté siempre visible
  panel.classList.add('open');
  panel.setAttribute('aria-hidden', 'false');
  setTimeout(() => input, 50);

  function norm(s) { return (s || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim(); }

  // Oculta el menú si el usuario hace clic fuera del formulario
  document.addEventListener('click', (event) => {
    if (!event.target.closest('#route-panel')) {
      //input.style.display = 'none';
    }
  });

  function renderDestOptions(filter = '') {
    const normalizedFilter = norm(filter);

    // Filtra las opciones basadas en la entrada del usuario
    const filteredPlaces = PLACES.filter(p => norm(p.title).includes(normalizedFilter));

    input.innerHTML = filteredPlaces
      .map(p => `<option class="custom-datalist-option" value="${p.title}">${p.title}</option>`)
      .join('');
  }

  input.addEventListener('focus', () => {
    // Cuando el input recibe foco, muestra el menú
    //renderDestOptions(input.value);
    input.style.display = 'block';
  });

  // Cuando el usuario teclea, intenta "enganchar" el item exacto por título
  input.addEventListener('input', () => {
    const q = norm(input.value);

    // Filtra las opciones a medida que el usuario teclea
    //renderDestOptions(input.value);

    _selectedDest = PLACES.find(p => norm(p.title) === q) || null;
    input.style.display = 'block';
  });

  // Cuando el usuario selecciona una opción del menú personalizado
  input.addEventListener('click', (event) => {
    if (event.target.classList.contains('custom-datalist-option')) {
      const selectedValue = event.target.getAttribute('value');
      input.value = selectedValue;

      // Fija la selección en la opción exacta
      _selectedDest = PLACES.find(p => p.title === selectedValue) || null;

      //input.style.display = 'none';
    }
  });

  // Si el usuario sale del input con un valor que coincide, también fija selección
  input.addEventListener('change', () => {
    const q = norm(input.value);
    _selectedDest = PLACES.find(p => norm(p.title) === q) || null;
  });


  // Geo inicial
  if (!('geolocation' in navigator)) {
    console.warn('Geolocalización no disponible. Uso fallback.');
    setOrigin(fallback);
    restoreStateFromStorage();
  } else {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setOrigin({ lat: pos.coords.latitude, lng: pos.coords.longitude });
        restoreStateFromStorage();
      },
      (err) => {
        console.warn('No se pudo obtener ubicación inicial:', err);
        setOrigin(fallback);
        restoreStateFromStorage();
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 30000 }
    );
  }

  await loadData();
  // Lugares: crea markers personalizados
  buildPlaceMarkers();
  renderDestOptions();

  /**
   * Dado un destCfg de tu PLACES (con coords o placeId),
   * retorna una Promise que resuelve a {lat, lng}
   */
  function getLatLngFromDestCfg(destCfg, mapInstance = _map) {
    // Si viene por placeId, resolvemos con Places Details
    if (destCfg?.placeId) {
      // Caché primero
      if (PLACE_CACHE.has(destCfg.placeId)) {
        return Promise.resolve(PLACE_CACHE.get(destCfg.placeId));
      }

      // Asegúrate de haber cargado la librería "places" en el script de Google Maps:
      // &libraries=places
      const svc = new google.maps.places.PlacesService(mapInstance);
      return new Promise((resolve, reject) => {
        svc.getDetails(
          {
            placeId: destCfg.placeId,
            fields: ['geometry'] // pedimos solo lo necesario
          },
          (place, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK && place?.geometry?.location) {
              const latLng = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
              };
              PLACE_CACHE.set(destCfg.placeId, latLng);
              resolve(latLng);
            } else {
              reject(new Error('No se pudo resolver el placeId a coordenadas. Status: ' + status));
            }
          }
        );
      });
    }

    return Promise.reject(new Error('destCfg no trae ni coords ni placeId válidos'));
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    // 1) Si hay selección exacta del datalist, úsala
    let destCfg = _selectedDest;

    // 2) Si no, intenta match por título (case/acentos-insensible)
    if (!destCfg) {
      const typed = input.value?.trim();
      if (!typed) return;
      destCfg = PLACES.find(p => norm(p.title) === norm(typed)) || null;
    }

    try {
      // Obtén {lat, lng} aunque venga por placeId
      const latLng = await getLatLngFromDestCfg(destCfg, _map);

      // Center + opcional zoom
      /* _map.panTo(latLng);
      _map.setZoom(18); // ajústalo a tu gusto */
      openCardForPlaceId(destCfg.id, {
        description: destCfg.description,
        position: new google.maps.LatLng(latLng.lat, latLng.lng)
      });

      // Si quieres, actualiza/crea un marcador aquí
      // upsertDestMarker(latLng); // (opcional)

      // Para Directions, normalización
      const dest = destCfg.placeId
        ? { placeId: destCfg.placeId }
        : { location: new google.maps.LatLng(latLng.lat, latLng.lng) };

      // Guarda para la ruta viva (persistes placeId o coords)
      saveDestToLS(destCfg.placeId
        ? { placeId: destCfg.placeId, title: destCfg.title }
        : { location: latLng, title: destCfg.title }
      );

      return;
    } catch (err) {
      console.error(err);
      // aquí puedes mostrar un toast/mensaje al usuario
    }
  });

  function setOrigin(p) {
    _lastOrigin = p;
    _map.setCenter(p);
    _marker.setPosition(p);
    _originSelection = { location: p };
    saveOriginToLS(p);
  }
}

// =========================
// Marcadores de PLACES
// =========================
function buildPlaceMarkers() {
  _placeMarkers.forEach((pm) => pm.marker.setMap(null));
  _placeMarkers = [];

  PLACES.forEach((cfg) => {
    if (cfg.placeId) {
      // Toma coords + foto de Places Details
      _placesService.getDetails({ placeId: cfg.placeId, fields: ['name', 'geometry', 'photos'] }, (res, status) => {
        if (status !== 'OK' || !res?.geometry?.location) {
          console.warn('No se pudieron cargar detalles de', cfg);
          return;
        }
        const pos = res.geometry.location;
        const photoUrl = res.photos?.[0]?.getUrl({ maxWidth: 96, maxHeight: 96 }) || null;
        createPlaceMarker({
          id: cfg.id,
          title: cfg.title || res.name,
          position: pos,
          iconUrl: cfg.iconUrl || photoUrl,
        });
      });
    } 
  });
}

function createPlaceMarker({ id, title, position, iconUrl }) {
  // 1) arma el glyph (imagen) como un <img>
  const glyphImg = document.createElement('img');
  glyphImg.className = 'pin-glyph';
  if (iconUrl) glyphImg.src = iconUrl;

  // 2) crea el PinElement (el "pin azul" de Google)
  const pin = new google.maps.marker.PinElement({
    background: '#1a73e8',      // color del pin
    borderColor: '#ffffff',     // borde del pin
    glyph: glyphImg,            // imagen dentro del pin
    scale: 1.0                  // tamaño base (Se puede ajustar)
  });

  // 3) wrapper para poder animar highlight con CSS
  const wrapper = document.createElement('div');
  wrapper.className = 'pin-wrapper';
  wrapper.appendChild(pin.element);

  // 4) Advanced Marker con el wrapper
  const am = new google.maps.marker.AdvancedMarkerElement({
    map: _map,
    position,
    content: wrapper,
    zIndex: 10
  });

  const data = { id, title, position, iconUrl };
  const pm = { id, am, wrapper, data, lastDistance: Infinity };
  _placeMarkers.push(pm);

  // Click -> define destino
  am.addListener('click', async () => {
    // se intenta obtener una imagen grande con resolvePlace; si falla, usamos la del icono
    let imageUrl = iconUrl || null;
    try {
      const cfg = PLACES.find(p => p.id === id) || { id, title, iconUrl };
      const resolved = await resolvePlace(cfg);
      if (resolved?.imageUrl) imageUrl = resolved.imageUrl;
    } catch { }

    document.getElementById('mapModal').style.display = "none";

    showPlaceCard({
      id,
      title: title || 'lugar',
      imageUrl,
      description: (PLACES.find(p => p.id === id)?.description) || '-',
      position
    }, true);
  });
}

function makeIcon(url, sizePx) {
  if (!url) {
    // Fallback: pin de color (SVG)
    const svg = {
      path: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7z',
      fillColor: '#1a73e8',
      fillOpacity: 1,
      strokeWeight: 2,
      strokeColor: '#ffffff',
      scale: sizePx / 24,
    };
    return svg;
  }
  return {
    url,
    scaledSize: new google.maps.Size(sizePx, sizePx),
    anchor: new google.maps.Point(sizePx / 2, sizePx), // base al “pico”
  };
}

// =========================
// Utilidades varias
// =========================
function saveOriginToLS(p) {
  try {
    localStorage.setItem(LS_KEYS.ORIGIN, JSON.stringify({ ...p, ts: Date.now() }));
  } catch { }
}
function loadOriginFromLS() {
  try {
    const raw = localStorage.getItem(LS_KEYS.ORIGIN);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
function saveDestToLS(dest) {
  try {
    const d = dest.placeId
      ? { placeId: dest.placeId, title: dest.title || '' }
      : {
        location: dest.location ? { lat: dest.location.lat(), lng: dest.location.lng() } : null,
        title: dest.title || '',
      };
    localStorage.setItem(LS_KEYS.DEST, JSON.stringify(d));
  } catch { }
}
function loadDestFromLS() {
  try {
    const raw = localStorage.getItem(LS_KEYS.DEST);
    if (!raw) return null;
    const d = JSON.parse(raw);
    if (d.placeId) return { placeId: d.placeId, title: d.title || '' };
    if (d.location && typeof d.location.lat === 'number') return { location: d.location, title: d.title || '' };
    return null;
  } catch {
    return null;
  }
}
function restoreStateFromStorage() {
  const o = loadOriginFromLS();
  if (o && (!_lastOrigin)) {
    _lastOrigin = { lat: o.lat, lng: o.lng };
    _marker && _marker.setPosition(_lastOrigin);
    _map && _map.panTo(_lastOrigin);
    _originSelection = { location: _lastOrigin };
  }
  const d = loadDestFromLS();
}

function toLiteral(pos) {
  if (!pos) return null;
  if (typeof pos.lat === 'function') return { lat: pos.lat(), lng: pos.lng() };
  return { lat: pos.lat, lng: pos.lng };
}

function escapeHtml(s) {
  return (s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt', '"': '&quot;', "'": '&#39;' }[c]));
}

// Registra/actualiza el índice de lugares ya resueltos (coords + imagen)
function registerResolvedPlace(obj) {
  _placesById[obj.id] = obj;
  return _placesById[obj.id];
}

// Resuelve un item de PLACES a {position (LatLng), imageUrl, title...}
function resolvePlace(cfg) {
  return new Promise((resolve) => {
    const cached = _placesById[cfg.id];
    if (cached?.position) return resolve(cached);

    // Si viene con placeId -> usa Places Details para geometry + foto
    if (cfg.placeId && _placesService) {
      _placesService.getDetails(
        { placeId: cfg.placeId, fields: ['name', 'geometry', 'photos'] },
        (res, status) => {
          if (status === 'OK' && res?.geometry?.location) {
            const position = res.geometry.location;
            const imageUrl = cfg.imageUrl || res.photos?.[0]?.getUrl({ maxWidth: 800, maxHeight: 600 }) || null;
            return resolve(registerResolvedPlace({
              id: cfg.id, title: cfg.title || res.name || '', position, imageUrl, placeId: cfg.placeId
            }));
          }
          resolve(null);
        }
      );
      return;
    }

    resolve(null);
  });
}

function normalizeHorarioTo24h(h) {
  if (!h) return null;
  let s = String(h).trim().toLowerCase();
  s = s.replace(/\s+/g, '').replace(/a\.?m\.?|p\.?m\.?/g, m => m[0] === 'p' ? 'pm' : 'am');

  // Soporta HH:mm, HH:mm:ss, y variantes con am/pm
  const m = s.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?(am|pm)?$/);
  if (!m) return null;

  let hh = parseInt(m[1], 10);
  const mm = parseInt(m[2], 10);
  const ss = parseInt(m[3] ?? '0', 10);
  const ap = m[4] || null;

  if (ap === 'pm' && hh < 12) hh += 12;
  if (ap === 'am' && hh === 12) hh = 0;

  if (hh > 23 || mm > 59 || ss > 59) return null;

  const HH = String(hh).padStart(2, '0');
  const MM = String(mm).padStart(2, '0');
  const SS = String(ss).padStart(2, '0');
  return `${HH}:${MM}:${SS}`;
}

// ==== Tarjeta reutilizable de lugar ====
// API pública rápida: openCardForPlaceId('p2', { description:'...', actionLabel:'Ver más' })
window.openCardForPlaceId = async function (id, opts = {}) {
  const cfg = PLACES.find(p => p.id === id);
  if (!cfg) return;
  ;
  // Resuelve coords + foto grande (usa resolvePlace que ya tienes)
  const full = await resolvePlace(cfg);
  if (!full) return;

  showPlaceCard({
    id: full.id,
    title: full.title || cfg.title || 'Lugar',
    description: opts.description || cfg.description || '—',
    position: full.position
  });
};

// Cierra el card
function hidePlaceCard() {
  const card = document.getElementById('place-card');
  if (!card) return;
  card.classList.remove('open');
  card.setAttribute('aria-hidden', 'true');
  card.innerHTML = ''; // limpia
}

// Muestra/arma el card
function showPlaceCard({ id, title, description, position }, fromMarker = false) {
  
  let card = document.getElementById('place-card');
  if (!card) return;

  card.style.display = 'block';

  // Guardamos lugar actual (id, title, coords)
  let pos = toLiteral(position);
  _currentPlace = { id, title, position: pos };

  // Centra la cámara suavemente en el marker
  try { _map && position && _map.panTo(position); } catch { }

  let safeTitle = escapeHtml(title || '');
  let safeDesc = escapeHtml(description || '');

  let horariosForPlace = HORARIOS.filter(h => h.placesId == id);
  let hasHorarios = horariosForPlace.length > 0;
  console.log("horarios por lugar: ", horariosForPlace);

  // construye el bloque de UI que reemplaza a place-card__desc
  let horariosBlock = hasHorarios
    ? `
        <label class="place-card__field" id="horarioField">
          <span>Selecciona horario</span>
          <select id="horarioSelect" class="place-card__select" style="border:1px solid #e2e2e2; border-radius:10px;">
            <option value="" selected disabled>Elige un horario</option>
            ${horariosForPlace.map(h => `<option data-horario-id="${h.id}" value="${h.horario}">${h.horario}</option>`).join('')}
          </select>
        </label>
        `
    : `<p class="place-card__desc">De momento no hay horarios</p>`;

  card.innerHTML = `
      <div class="place-card__body">
        <h3 class="place-card__title">${safeTitle}</h3>

        ${horariosBlock}

        <div class="place-card__fields">
        </div>
          <div class="quantity-selector" style="justify-content: center;">
            <p>Adultos:</p>
            <button class="quantity-btn" onclick="changeQtySeats(-1)">-</button>
            <span class="quantity-display" id="qtyInput">0</span>
            <button class="quantity-btn" onclick="changeQtySeats(1)" disabled>+</button>
          </div>
          <div class="quantity-selector" style="justify-content: center;">
            <p>Niños:</p>
            <button class="quantity-btn" onclick="changeQtyChildSeats(-1)">-</button>
            <span class="quantity-display" id="qtyInputNinos">0</span>
            <button class="quantity-btn" onclick="changeQtyChildSeats(1)" disabled>+</button>
          </div>                 
        <div class="place-card__actions">
          <button type="button" id="btn-add-to-cart" class="place-card__btn" data-place="${id}">Confirmar</button>
        </div>
      </div>
    `;

  let qtsPassports = document.getElementById('qty-cart').value
  let qtsPassportsChild = document.getElementById('qty-cart-child').value

  document.getElementById('qtyInput').value = qtsPassports
  document.getElementById('qtyInput').textContent = qtsPassports
  document.getElementById('qtyInputNinos').value = qtsPassportsChild
  document.getElementById('qtyInputNinos').textContent = qtsPassportsChild

  // guarda el id del horario seleccionado en _currentPlace
  let horarioSelect = card.querySelector('#horarioSelect');
  if (horarioSelect) {
    horarioSelect.addEventListener('change', () => {
      const selectedOption = horarioSelect.options[horarioSelect.selectedIndex]
      horarioId = selectedOption.dataset.horarioId || null;
      _currentPlace.horario = horarioSelect.value || null;
    });
  }

  const hiddenDate = document.getElementById('dateInput');
  const globalDate = document.querySelector('section #dateInput');
  if (globalDate && hiddenDate) hiddenDate.value = globalDate.value || '';

  // accesibilidad / eventos
  const onClose = () => {
    hidePlaceCard();
    // Limpia listeners para evitar fugas
    card.querySelector('.place-card__close')?.removeEventListener('click', onClose);
    document.removeEventListener('keydown', onEsc);
    card.querySelector('#btn-add-to-cart')?.removeEventListener('click', onAdd);
  };
  const onEsc = (ev) => { if (ev.key === 'Escape') onClose(); };
  card.querySelector('.place-card__close')?.addEventListener('click', onClose);

  const onAdd = async () => {
    try {      
      const dateFieldInCard = card.querySelector('#dateInput');
      const qtyField = card.querySelector('#qtyInput');
      const qtyFieldNinos = card.querySelector('#qtyInputNinos');
      const fecha = document.getElementById('dateInput').value
      const qty = Math.max(1, parseInt(qtyField?.value || '1', 10));
      const qtyNinos = Math.max(0, parseInt(qtyFieldNinos?.value || '0', 10));

      if (!_currentPlace?.id) {
        alert('Selecciona un lugar válido');
        return;
      }

      // si este punto tiene horarios, obligamos a elegir uno
      const horariosDelPunto = HORARIOS.filter(h => h.placesId === _currentPlace.id);
      let hhmmss = null;
      if (horariosDelPunto.length > 0) {
        hhmmss = normalizeHorarioTo24h(_currentPlace?.horario);
        if (!hhmmss) { alert('Selecciona un horario válido.'); return; }
      } else {
        // sin horarios definidos para el punto -> opcional: fija 00:00:00
        hhmmss = '00:00:00';
      }

      // 1. Separamos la fecha (MM, DD, YYYY)
      const [mes, dia, anio] = fecha.split('/');

      // 2. Separamos la hora (hh, mm, ss)
      const [hora, min, seg] = hhmmss.split(':');

      // 3. Creamos la fecha usando Date.UTC()
      const fechaUTC = Date.UTC(anio, mes - 1, dia, hora, min, seg);

      const fechaISO = new Date(fechaUTC).toISOString();

      jsonTransporte = {
        quantity: qty + qtyNinos
      }

      document.getElementById('place-card').style.display = "none"
      document.getElementById('map-container').style.display = "none"
      if (document.querySelectorAll('.seleccionada').length == 0) {
        Swal.fire({
          title: 'Por favor selecciona los asientos para finalizar tu compra.'
        });
      }

      quantity = qty + qtyNinos;

      await showSubTotalTransporte();

      await buildJsonInsert({
        ubicacionId: _currentPlace.id,
        placeTitle: _currentPlace.title,
        horarioId,
        fechaISO,
        quantity: qty,
        quantityNinos: qtyNinos,
        token: token
      });
      document.getElementById('container-select-location').style.bottom = "0"
              Swal.fire({
          title: 'Transporte confirmado.'
        });
      //window.location.href = '/cart';
    } catch (err) {
      console.error('Error al añadir al carrito: ', err);
      alert('No se pudo añadir al carrito. Intenta de nuevo');
    }
  };

  card.querySelector('.__close')?.addEventListener('click', onClose);
  document.addEventListener('keydown', onEsc);
  card.querySelector('#btn-add-to-cart')?.addEventListener('click', onAdd);

  card.classList.add('open');
  card.setAttribute('aria-hidden', 'false');
  const contenedor = document.querySelector('.container-filters');
  if (contenedor) {
    // contenedor.scrollTop = contenedor.scrollHeight;
    // Scroll del contenedor .container-filters hasta #place-card
    scrollToPlaceCard()
    if(fromMarker){
      let existingOption = Array.from(document.getElementById('dest-input').options).find(opt => opt.text === title);
      document.getElementById('dest-input').value = existingOption.value;
    }
  }
}

function scrollToPlaceCard() {
  var cont = document.querySelector('.container-filters');
  var card = document.getElementById('place-card');
  if (!cont || !card) return;
  cont.scrollTo({ top: card.offsetTop - cont.offsetTop, behavior: 'smooth' });
}

async function buildJsonInsert({ ubicacionId, placeTitle, horarioId, fechaISO, quantity, quantityNinos, token }) {
  var req = await fetch(`https://grupopanaca.com.do/transporteapi/api/transportepanaca/rutas?transporteUbicacionId=${ubicacionId}&transporteHorarioId=${horarioId}`)
  var ruta = await req.json();

  const RUTAS_1_5 = [1, 2, 3, 4, 5];
  const RUTA_6y7 = [6, 7];

  if (RUTAS_1_5.includes(ruta.transporteRutaID) && document.getElementById('checkBoxResidente').checked != true) {
    VIAJE_VARIANT_ID = Number($section?.dataset.variantInternacionales)
  } else if (RUTAS_1_5.includes(ruta.transporteRutaID)) {
    VIAJE_VARIANT_ID = Number($section?.dataset.variantLocales)
  } else if (RUTA_6y7.includes(ruta.transporteRutaID)) {
    VIAJE_VARIANT_ID = Number($section?.dataset.variantRuta6y7)
  } else if (ruta.transporteRutaID == 8) {
    VIAJE_VARIANT_ID = Number($section?.dataset.variantRuta6y7)
  }

  if (!VIAJE_VARIANT_ID) {
    throw new Error('No se configuró el producto "viaje" (variant id ausente).');
  }

  jsonTransporte.id = VIAJE_VARIANT_ID;

  const qty = Math.max(1, Number(quantity) || 1);
  const qtyNinos = Math.max(1, Number(quantityNinos) || 1);

  jsonReservas = {
    fechaRuta: fechaISO,
    transporteRutaUbicacionID: ruta.transporteRutaUbicacionID,
    cantidad: String(qty),
    cantidadNinos: String(qtyNinos),
    token: token,
    tipo: 'voucherPortalId'
  }
}

async function showSubTotalTransporte() {
  var req = await fetch(`https://grupopanaca.com.do/transporteapi/api/transportepanaca/rutas?transporteUbicacionId=${_currentPlace.id}&transporteHorarioId=${horarioId}`)
  var ruta = await req.json();
  let esResidente = document.getElementById('checkBoxResidente').checked;
  let selectedUbicacion = PLACES.filter(p => p.id == _currentPlace.id);
  let precioTransporte = 0;
  let precioTransporteDOP = 0;
  const subTotalUbi = document.getElementById('subTotalTransporte');

  const RUTAS_1_5 = [1, 2, 3, 4, 5];
  const RUTA_6y7 = [6, 7];

  if (RUTAS_1_5.includes(ruta.transporteRutaID) && esResidente != true) {
    precioTransporte = selectedUbicacion[0].precio * quantity;
    precioTransporteDOP = precioTransporte * 63;
    VIAJE_VARIANT_ID = Number($section?.dataset.variantInternacionales)
    if(subTotalUbi) subTotalUbi.textContent = `Transporte: $${precioTransporte.toFixed(2)} USD - $${precioTransporteDOP.toLocaleString('es-DO', { maximumFractionDigits: 0 })} DOP`;
  } else if (RUTAS_1_5.includes(ruta.transporteRutaID)) {
    precioTransporte = selectedUbicacion[0].precioLocal * quantity;
    precioTransporteDOP = precioTransporte * 63;
    VIAJE_VARIANT_ID = Number($section?.dataset.variantLocales)
    if(subTotalUbi) subTotalUbi.textContent = `Transporte: $${precioTransporte.toFixed(2)} USD - $${precioTransporteDOP.toLocaleString('es-DO', { maximumFractionDigits: 0 })} DOP`;
  } else if (RUTA_6y7.includes(ruta.transporteRutaID)) {
    precioTransporte = selectedUbicacion[0].precioLocal * quantity;
    precioTransporteDOP = precioTransporte * 63;
    VIAJE_VARIANT_ID = Number($section?.dataset.variantRuta6y7)
    if(subTotalUbi) subTotalUbi.textContent = `Transporte: $${precioTransporte.toFixed(2)} USD - $${precioTransporteDOP.toLocaleString('es-DO', { maximumFractionDigits: 0 })} DOP`;
  } else if (ruta.transporteRutaID == 8) {
    precioTransporte = selectedUbicacion[0].precioLocal * quantity;
    precioTransporteDOP = precioTransporte * 63;
    VIAJE_VARIANT_ID = Number($section?.dataset.variantRuta6y7)
    if(subTotalUbi) subTotalUbi.textContent = `Transporte: $${precioTransporte.toFixed(2)} USD - $${precioTransporteDOP.toLocaleString('es-DO', { maximumFractionDigits: 0 })} DOP`;
  }

  jsonTransporte.quantity = quantity;
  jsonTransporte.id = VIAJE_VARIANT_ID;
}

async function createReserva(reservaProps) {
  const res = await fetch(`https://grupopanaca.com.do/transporteapi/api/transportepanaca/reservas`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(reservaProps)
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    throw new Error(`Fallo al crear la reserva (${res.status}): ${txt}`);
  }
  return res.json(); // asume que tu API devuelve {reservaId: ..., ...}
}

// Función de utilidad para obtener el valor inicial de un elemento
/* function getInitialQty(element) {
  if (!element) return 0;
  // Lee el contenido o el valor (asumiendo que es un input o un span)
  return parseInt(element.textContent || element.value || "0", 10);
}

document.addEventListener('DOMContentLoaded', (event) => {
    // ESTE CÓDIGO SOLO SE EJECUTA CUANDO EL DOM ESTÁ LISTO
    
    const initialAdultsElement = document.getElementById("qty-cart");
    const initialChildsElement = document.getElementById("qty-cart-child");
    
    // Inicializar las variables globales leyendo los valores del DOM
    quantityAdults = getInitialQty(initialAdultsElement);
    quantityChilds = getInitialQty(initialChildsElement);
    quantity = quantityAdults + quantityChilds; // Calcular el total inicial

    // Opcional: Ejecutar las funciones de cálculo inicial aquí si es necesario
    // showSubTotal();
    // showSubTotalTransporte();
}); */

/*
** =================================
** Lógica del carrito de compra 
** =================================
*/
async function addTicketToCart(jsonTransporte) {
  
  const payload = {
    items: [jsonTransporte],
    // Puedes guardar una nota de carrito genérica (opcional)
    /* note: `Fecha: ${fechaISO} | Lugar: ${placeTitle || ubicacionId}` */
  };

  const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    throw new Error(`Fallo al agregar al carrito (${res.status}): ${txt}`);
  }

  const json = await res.json();
  if (json?.status === 422) {
    alert('Producto agotado o no disponible.');
  }

  await createReserva(jsonReservas);

  return json;
}